import CustomReportsListPage from './CustomReportsListPage';

export default CustomReportsListPage;
